<script setup>
const props = defineProps({
  increase: {
    type: String,
    required: true
  }
})

// Remove any stray "%" and trim
const rawValue = props.increase.replace('%', '').trim()
const isNegative = rawValue.startsWith('-')

// Ensure clean formatting with % at the end
const formattedValue = `${rawValue.replace('-', '')} %`
</script>

<template>
  <span
    :class="[
      'badge badge-sm text-[10px] font-normal rounded-full',
      isNegative
        ? 'text-error border-error/20'
        : 'text-success border-success/20'
    ]"
  >
    {{ isNegative ? `- ${formattedValue}` : `+ ${formattedValue}` }}
  </span>
</template>